import { UseQueryResult, useQuery } from "react-query";

import { useAuth } from "../../sdk/hooks/useAuth";
import { IRecipeTag } from "../../sdk/types";
import { recipeTags } from "../../sdk/utils/api";

export const useGetRecipeTags = (): UseQueryResult<IRecipeTag[]> => {
    const auth = useAuth();

    return useQuery<IRecipeTag[]>("recipeTags", async () => {
        if (!auth.token) {
            throw new Error(
                "Cannot fetch recipe tags without authorization token.",
            );
        }

        return await recipeTags.RecipeTag.list({ token: auth.token });
    });
};
